import DotLogo from './DotLogo/DotLogo';
import MainHeaderSearch from './MainHeaderSearch/MainHeaderSearch';
import { useSetAccountIdFromUser } from 'hooks';
import { useCurrentUser } from 'state';
import styles from './MainHeaderBar.module.scss';

export default function MainHeaderBar() {
    const user = useCurrentUser();
    useSetAccountIdFromUser();

    return(

            <div className={styles.mainHeaderBarContainer}>
                <div className={styles.logo}>       
                    <DotLogo />
                </div>
                <div className={styles.search}>
                    <MainHeaderSearch />
                </div>
                <div className={styles.user}>Welcome, {user?.firstName}</div>
            </div>
    )
}